import { UserPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (): UserPointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.USER_POINTER,
  variable: null,
});
